/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */


// import ScrollMagic from 'ScrollMagic';
// import animationGSAP from 'animation.gsap';
// import addIndicators from 'debug.addIndicators';
// import TweenMax from 'TweenMax';
// import TimelineMax from 'TimelineMax';
import noUiSlider from 'nouislider';
import wNumb from 'wnumb';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      // Go to prev page
      $( '.quoter-tool .quoter-back' ).click( function() {
        $( '.current-page .gform_previous_button' ).trigger( 'click' );
      } );

      // Go to next page
      $( document ).on( 'click', '.quoter-skip', function() {
        $( '.current-page .gform_page_fields input, .current-page .gform_page_fields select' ).val( '' );
        $( '.current-page .gform_next_button' ).trigger( 'click' );
      } );

      const llQuoterTool = document.querySelector( '.quoter-page' );
      const headerVisibility = document.querySelector( '.header-visibility' );
      const footerVisibility = document.querySelector( '.footer-visibility' );
      console.log( llQuoterTool );
      if ( llQuoterTool ) {
        $( headerVisibility ).toggleClass( 'hidden' );
        $( footerVisibility ).toggleClass( 'hidden' );
        $( 'body' ).css( 'padding-top', 0 );
      } else {
        $( headerVisibility ).removeClass( 'hidden' );
        $( footerVisibility ).removeClass( 'hidden' );
      }

      // Go to next page on radio click
      $( document ).on( 'click', '.radio-page input[type="radio"]', function() {
        $( '.current-page .gform_next_button' ).trigger( 'click' );
      } );

      $( document ).on( 'click', '.quoter-next', function() {
        $( '.current-page .gform_next_button' ).trigger( 'click' );
      } );

      // Set Current Page
      $( '.quoter-form .gform_page:first-child' ).addClass( 'current-page' );

      // Page change stuff
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        $( '.quoter-nav .nav-progress-wrapper' ).html( $( '.quoter-area .gf_progressbar_wrapper' ).html() );
        initSliders( $( '#gform_page_' + formId +'_' + currentPage )[0] );

        // Update quoter nav
        if ( currentPage > 1 ) {
          $( '.quoter-tool .quoter-back' ).removeClass( 'invisible' );
        } else {
          $( '.quoter-tool .quoter-back' ).addClass( 'invisible' );
        }

        if ( currentPage == 7 ) {
          $( '.quoter-nav' ).addClass( 'invisible' );
        }

        // Add skip item link
        if ( $( '#gform_page_' + formId +'_' + currentPage ).hasClass( 'skippable' ) ) {
          $( '#gform_page_' + formId +'_' + currentPage ).find( '.gform_page_footer' ).append( '<button class="quoter-skip text-gray-300 text-sm order-3 mt-1 underline hover:text-blue">Skip</button>' );
        }

        // Set current page, scroll to top
        $( '.quoter-form .gform_page' ).removeClass( 'current-page' );
        $( '#gform_page_' + formId +'_' + currentPage ).addClass( 'current-page' );
        $( 'html, body' ).animate( {scrollTop: 0}, 'slow' );
      } );

      // Hide quoter nav on submit
      $( document ).on( 'gform_confirmation_loaded', function( event, formId ) {
        $( '.quoter-nav' ).hide();
      } );

      function initSliders( page ) {
        $( page ).find( '.real-slider' ).each( function( key, val ) {
          if ( $( page ).attr( 'data-slider-created' ) !== 'true' ) {
            let savedVal = 10000;
            let endVal = savedVal + ( savedVal / 0.1 );
            let minVal = 1000;
            let maxVal = 50000;
            let decimals = 0;
            let prefix = '';
            let suffix = '';

            /*
             * Example class for slider field:
             * slider range currency min-1000 max-50000 start-10000 end-20000
             */

            if ( $( val ).closest( '.gfield' ).hasClass( 'currency' ) ) {
              prefix = '$';
            }

            if ( $( val ).closest( '.gfield' ).hasClass( 'percentage' ) ) {
              decimals = '1';
              suffix = '%';
            }

            if ( $( val ).closest( '.gfield' ).attr( 'class' ).match( /\bstart\S+/ ) ) {
              savedVal = parseFloat( $( val ).closest( '.gfield' ).attr( 'class' ).match( /\bstart\S+/ )[0].replace( 'start-', '' ) );
            }

            if ( $( val ).closest( '.gfield' ).attr( 'class' ).match( /\bend\S+/ ) ) {
              endVal = parseFloat( $( val ).closest( '.gfield' ).attr( 'class' ).match( /\bend\S+/ )[0].replace( 'end-', '' ) );
            }

            if ( $( val ).closest( '.gfield' ).attr( 'class' ).match( /\bmin\S+/ ) ) {
              minVal = parseFloat( $( val ).closest( '.gfield' ).attr( 'class' ).match( /\bmin\S+/ )[0].replace( 'min-', '' ) );
            }

            if ( $( val ).closest( '.gfield' ).attr( 'class' ).match( /\bmax\S+/ ) ) {
              maxVal = parseFloat( $( val ).closest( '.gfield' ).attr( 'class' ).match( /\bmax\S+/ )[0].replace( 'max-', '' ) );
            }

            if ( $( val ).closest( '.gfield' ).find( 'input' ).val() ) {
              savedVal = parseFloat( $( val ).closest( '.gfield' ).find( 'input' ).val().replace( '$', '' ).replace( 'K', '000' ).replace( 'M', '000000' ) );
            }

            if ( $( val ).closest( '.gfield' ).hasClass( 'range' ) ) {
              noUiSlider.create( val, {
                start: [parseFloat( savedVal ), parseFloat( endVal )],
                step: 25000,
                tooltips: true,
                connect: true,
                range: {
                  'min': minVal,
                  'max': maxVal,
                },
                format: wNumb( {
                  decimals: decimals,
                  prefix: prefix,
                  suffix: suffix,
                } ),
                pips: {
                  mode: 'range',
                  density: 10000,
                  format: wNumb( {
                    decimals: decimals,
                    prefix: prefix,
                    suffix: suffix,
                    edit: function( a ) {
                      const formattedA = a.replace( '$', '' );
                      if ( formattedA < 1000 ) {
                        return prefix + formattedA + suffix;
                      } else if ( formattedA < 1000000 ) {
                        return prefix + ( formattedA / 1000 ).toFixed( 0 ) + 'K' + suffix;
                      } else {
                        return prefix + ( formattedA / 1000000 ).toFixed( 1 ) + 'M' + suffix;
                      }
                    },
                  } ),
                },
              } );
            } else {
              noUiSlider.create( val, {
                start: [parseFloat( savedVal )],
                tooltips: true,
                range: {
                  'min': minVal,
                  'max': maxVal,
                },
                format: wNumb( {
                  decimals: decimals,
                  prefix: prefix,
                  suffix: suffix,
                } ),
                pips: {
                  mode: 'range',
                  density: 10000,
                  format: wNumb( {
                    decimals: decimals,
                    prefix: prefix,
                    suffix: suffix,
                  } ),
                },
              } );
            }
          }

          val.noUiSlider.on( 'update', function( values, handle ) {
            let prefix = '';
            let suffix = '';

            if ( $( val ).closest( '.gfield' ).hasClass( 'currency' ) ) {
              prefix = '$';
            }

            if ( $( val ).closest( '.gfield' ).hasClass( 'percentage' ) ) {
              suffix = '%';
            }

            let minVal = parseFloat( values[0].replace( '$', '' ).replace( '%', '' ) );

            if ( minVal < 1000 ) {
              // minVal = minVal;
            } else if ( minVal < 1000000 ) {
              minVal = ( minVal / 1000 ).toFixed( 0 ) + 'K';
            } else {
              minVal = ( minVal / 1000000 ).toFixed( 1 ) + 'M';
            }

            $( val ).find( '.noUi-handle-lower .noUi-tooltip' ).text( prefix + minVal + suffix );

            if ( values[1] ) {
              let maxVal = parseFloat( values[1].replace( '$', '' ) );

              if ( maxVal < 1000 ) {
                // maxVal = maxVal;
              } else if ( maxVal < 1000000 ) {
                maxVal = ( maxVal / 1000 ).toFixed( 0 ) + 'K';
              } else {
                maxVal = ( maxVal / 1000000 ).toFixed( 1 ) + 'M';
              }

              $( val ).find( '.noUi-handle-upper .noUi-tooltip' ).text( prefix + maxVal + suffix );
              $( val ).closest( '.gfield' ).find( 'input' ).val( minVal + ' - ' + maxVal );
            } else {
              $( val ).closest( '.gfield' ).find( 'input' ).val( minVal );
            }
          } );
        } );
      }

      // Initialize sliders
      initSliders( $( '.quoter-form .gform_page:first-child' )[0] );
    },
    finalize: function() {
    },
  };
  app.registerComponent( 'quoter', COMPONENT );
} )( app );
